import React, { PropTypes } from 'react';
import Tooltip from 'react-tooltip';
import { v4 } from 'node-uuid';
import { isMobile } from 'common/utils';

const FeesLabel = ({ label }) => {
  const key = v4();

  return (
    <span>
      <span data-tip={true} data-for={`fees-tooltip-${key}`}
          data-event={isMobile()? "click" : undefined}>
        { label || "crowdspring fee" }
      </span>
      <Tooltip class="tooltip" effect="solid" place="top" id={`fees-tooltip-${key}`}>
        Our fees cover the cost to host the project, <br className="hide-for-small-only" />
        our award-winning tools, escrow and payment, <br className="hide-for-small-only" />
        and custom legal contracts and non-disclosure <br className="hide-for-small-only" />
        agreements.
      </Tooltip>
    </span>
  );
}

FeesLabel.propTypes = {
  label: PropTypes.string
};

export default FeesLabel;
